.shell { min-height: 100vh; max-width: 1440px; margin: 0 auto; }
.bar { height: 82px; display: flex; align-items: center; justify-content: space-between; padding: 0 var(--page-x); background: var(--paper); border-bottom: var(--border-hair); }
.nav { display: flex; gap: 30px; }
.navLink { font-family: var(--font-mono); font-size: 11px; letter-spacing: 1.3px; color: var(--ink); }
.navLink[aria-current='page'] { color: var(--hot); }
.right { display: flex; align-items: center; gap: 14px; }
.pill { padding: 9px 14px; border: var(--border-hair); border-radius: 20px; font-family: var(--font-mono); font-size: 9px; line-height: 1; letter-spacing: 1px; color: var(--text-secondary); white-space: nowrap; }
/* Inline (not flex) so the space after "STRAVA ·" survives as a normal word space. */
.pill::before { content: ''; display: inline-block; width: 7px; height: 7px; margin-right: 8px; vertical-align: -1px; border-radius: 50%; background: var(--green); }
.pill[data-tone='amber']::before { background: var(--amber); }
.pill[data-tone='hot']::before { background: var(--hot); }
.avatar { display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: var(--pink); border: 2px solid var(--ink); font-family: var(--font-cond); font-size: 15px; font-weight: 900; }
.main { display: block; }
.attribution { display: flex; justify-content: flex-end; padding: 0 var(--page-x) 24px; }
.notFound { padding: 36px var(--page-x); }

@media (max-width: 639px) {
  .bar { height: 56px; padding: 0 16px; }
  .nav { display: none; }
  .pill { padding: 8px 10px; }
  .avatar { position: relative; }
  .avatar::before { content: ''; position: absolute; inset: -6px; }
  .main { padding-bottom: calc(60px + env(safe-area-inset-bottom)); }
}
